// ═══════════════════════════════════════════════════════════════
// ClearView CRM Member Types & CFRE Options
// ═══════════════════════════════════════════════════════════════

export const MEMBER_TYPES = [
  "Professional", "Young Professional", "Associate", "Retired",
  "Student", "Complimentary", "Honorary", "Other"
];

export const CFRE_OPTIONS = [
  { value: "", label: "Not Certified" },
  { value: "Yes", label: "CFRE Certified" },
  { value: "No", label: "Not Certified" }
];

export const DONOR_TYPES = [
  { value: "individual", label: "Individual" },
  { value: "household", label: "Household" },
  { value: "organization", label: "Organization" },
];

export const RELATIONSHIP_TYPES = [
  { value: "spouse", label: "Spouse" },
  { value: "child", label: "Child" },
  { value: "parent", label: "Parent" },
  { value: "employee", label: "Employee" },
  { value: "board_contact", label: "Board Contact" },
  { value: "other", label: "Other" },
];
